<div class="header">
    <div class="left">
        <a href="#"><img src="/assets/images/generico/logo.png" class="logo"></a>
    </div>

    <div class="right">
        <span class="user-name" *ngIf="identity || token && false">
            {{ identity?.nombres + ' ' + identity?.apellidoP + ' ' + identity?.apellidoM }}
        </span>
        <button mat-button [matMenuTriggerFor]="menu" *ngIf="identity || token && false">
            <mat-icon class="icon" matBadgeColor="warn">person</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="openPerfil()">
                <mat-icon matBadgeColor="warn">person</mat-icon> Mi perfil
            </button>
            <button mat-menu-item (click)="logout()">
                <mat-icon>exit_to_app</mat-icon> Cerrar Sesi&oacute;n
            </button>
        </mat-menu>
        <button mat-icon-button matTooltip="Servicios" aria-label="Volver al inicio" (click)="back()">
            <mat-icon class="icon">home</mat-icon>
        </button>
    </div>
</div>


<div class="container" *ngIf="!buscando && bandera">

    <mat-card class="example-card">
        <mat-card-header>
            <div class="row" style="width: 100%;">
                <div mat-card-avatar class="example-header-image"></div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="title1b">Tótem de consulta</div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 subTitle">
                    <p>Dirección de Obras Municipales</p>
                </div>
            </div>
        </mat-card-header>
        <mat-card-content>

            <div class="row">

                <div class="rol-div">
                    <h4 class="card-title">Búsqueda por Rol</h4>
                    <mat-form-field class="mat-field-rol">
                        <input matInput type="text" placeholder="Nº Rol" [formControl]="rol">
                        <button mat-button *ngIf="rol.value" matSuffix mat-icon-button aria-label="Clear"
                            (click)="rol.setValue('')">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </div>

            </div>

            <div class="row">

                <div class="rol-div">
                    <h4 class="card-title">Búsqueda por Dirección</h4>
                    <mat-form-field class="mat-field-calle">
                        <input matInput type="text" placeholder="Calle" [formControl]="calle" [matAutocomplete]="auto">
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                {{option}}
                            </mat-option>
                        </mat-autocomplete>
                        <button mat-button style="margin: 0px;" *ngIf="calle.value" matSuffix
                            mat-icon-button aria-label="Clear" (click)="calle.setValue('')">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>&nbsp;
                    <mat-form-field class="mat-field-rol">
                        <input matInput type="text" placeholder="Nº Calle" [formControl]="nroCalle">
                        <button mat-button *ngIf="nroCalle.value" matSuffix mat-icon-button aria-label="Clear"
                            (click)="nroCalle.setValue('')">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </div>

                <div class="btn-cont">
                    <button class="btn-busqueda" mat-raised-button
                        (click)="buscar(rol.value, calle.value, nroCalle.value)"
                        [disabled]="((!rol.valid && !calle.valid && !nroCalle.valid) || (rol.valid && calle.valid) || (rol.valid && nroCalle.valid)) ">Búsqueda</button>
                </div>






            </div>



        </mat-card-content>
        <mat-card-actions></mat-card-actions>
    </mat-card>



    <mat-card>
        <mat-card-content>

        </mat-card-content>
    </mat-card>



</div>



<div class="container" *ngIf="buscando">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <p align="right">
                <button color="primary" mat-raised-button (click)="volver()">Volver a buscar</button>
            </p>




            <mat-card class="example-card">
                <mat-card-header>
                    <div class="row" style="width: 100%;">
                        <div class="get-data-cont">
                            <p align="center"> Rol : {{ rol_busqueda }}</p>
                            <mat-tab-group>
                                <mat-tab label="Información">
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12 col-sm-12 div-inforol-cont">

                                            <div class="col-lg-4 col-md-4 -col-sm-4">
                                                <label>Ubicación</label><input matInput
                                                    [value]="ubicacion ? ubicacion : '---'" disabled>
                                            </div>
                                            <div class="col-lg-4 col-md-4 -col-sm-4">
                                                <label>Manzana</label><input matInput
                                                    [value]="manzana ? manzana : '---'" disabled>
                                            </div>
                                            <div class="col-lg-4 col-md-4 -col-sm-4">
                                                <label>Lote / Sitio</label><input matInput
                                                    [value]="sitio ? sitio : '---'" disabled>
                                            </div>
                                        </div>

                                        <div class="col-lg-12 col-md-12 col-sm-12 mapinfo-div">
                                            <div class="col-lg-4 col-md-4 -col-sm-4">
                                                <label>Zona PRC</label><input matInput
                                                    [value]="zonaprc ? zonaprc : '---'" disabled>
                                            </div>
                                            <div class="col-lg-4 col-md-4 -col-sm-4">
                                                <label>Conjunto Habitacional</label><input matInput
                                                    [value]="conjHabit ? conjHabit : '---'" disabled>
                                            </div>
                                            <div class="col-lg-4 col-md-4 -col-sm-4">
                                                <label>Afectacion a Utilidad Pública (AUP)</label><input matInput
                                                    [value]="aup ? aup : '---'" disabled>
                                            </div>
                                        </div>



                                        <div class="col-lg-12 col-md-12 col-sm-12 div-table-inforol">

                                            <table mat-table [dataSource]="direcciones" class="mat-elevation-z8">

                                                <!--- Note that these columns can be defined in any order.
                                                          The actual rendered columns are set as a property on the row definition" -->

                                                <ng-container matColumnDef="PDI_Direc_Completa">
                                                    <th mat-header-cell *matHeaderCellDef align="left"> Dirección </th>
                                                    <td mat-cell *matCellDef="let element" align="left">
                                                        {{ element['PDI_Direc_Completa'] }} </td>
                                                </ng-container>

                                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                            </table>


                                        </div>

                                    </div>
                                </mat-tab>

                                <mat-tab label="Ubicación en Mapa">

                                    <div #mapContainer id="map" (centerChange)="centerChange($event)"
                                        (boundsChange)="ChangeMap($event)"></div>


                                </mat-tab>
                            </mat-tab-group>
                        </div>
                    </div>
                </mat-card-header>
                <mat-card-content>
                    <div class="row">

                    </div>
                </mat-card-content>
                <mat-card-actions>

                </mat-card-actions>
            </mat-card>

        </div>
    </div>



</div>

<ng-template #direccionesDialog>
    <h2 style="color: tomato;" mat-dialog-title>Direcciones existentes en el rol</h2>
    <!-- <label id="example-radio-group-label">Seleccione una dirección:</label> -->
    <mat-dialog-content style="width: 400px;
    overflow: hidden auto;">
        <br>
        <div class="alert alert-info" role="alert">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
            <strong> Debe seleccionar una de las direcciones</strong>
        </div>
        <div id="search-box-div" style="text-align: center; padding-bottom: 5px;">
            <div id="search-field" class="top-div">
                <input #input type="text" placeholder="Buscar" [(ngModel)]="searchText">
            </div>
        </div>
        <ul class="list-group">
            <li class="list-group-item"
                *ngFor="let dir of dires | filter: searchText | paginate: {itemsPerPage: 10, currentPage: p}">

                <input type="radio" id="direccionSelec" name="direccionSelect" [value]="dir" name="modal_dir"
                    [(ngModel)]="dirSeleccionada">
                <span style="margin-left: 4px;">{{dir.PDI_Direc_Completa}}</span><span style="float: right;">{{ dir['Propiedad::Pro_Propie_ROL'] }}</span>
            </li>
        </ul>
        <div style="text-align:center">
            <pagination-controls [nextLabel]="'Siguiente'" [previousLabel]="'Anterior'" (pageChange)="p = $event">
            </pagination-controls>
        </div>
        <!-- <mat-radio-group aria-labelledby="example-radio-group-label" [(ngModel)]="dirSeleccionada"
            class="example-radio-group">
            <div class="row">
                <mat-radio-button class="example-radio-button" *ngFor="let dir of dirrecciones.dirs" [value]="dir">
                    {{ dir.direcCompleta }}
                </mat-radio-button>
            </div>
        </mat-radio-group> -->
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal">Cancelar</button>
        <button mat-raised-button color="primary" id="ingreso_propiet" (click)="insertarDir()">Ingresar Propiedad <i
                class="fa fa-user-o" aria-hidden="true"></i></button>
    </mat-dialog-actions>
</ng-template>